/**
 * Pairs every current buyer with the version stored before the update started,
 * so a cancelled update can restore the original data. Current buyers without a
 * stored version are skipped instead of being restored as `undefined`.
 */
export function collectBuyersToRestore(currentBuyers, previousBuyers) {
  if (!Array.isArray(currentBuyers) || !Array.isArray(previousBuyers)) {
    return [];
  }

  return currentBuyers
    .map((currentBuyer) => previousBuyers.find(
      (previousBuyer) => previousBuyer.identityCode === currentBuyer.identityCode,
    ))
    .filter((previousBuyer) => Boolean(previousBuyer));
}
